export enum ResultStatus {
	FULFILLED = 'fulfilled',
	FAILED = 'failed',
}
